module.exports = __webpack_public_path__ + "img/wellwellwell-session-1.1fb88682.png";